import { useEffect, useState } from "react";

export const useShouldAutoScroll = (containerElement: HTMLElement | null) => {
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);

  useEffect(() => {
    setShouldAutoScroll(true);

    const stopAutoScroll = () => setShouldAutoScroll(false);

    containerElement?.addEventListener("wheel", stopAutoScroll, {
      passive: true,
    });
    containerElement?.addEventListener("touchmove", stopAutoScroll, {
      passive: true,
    });

    return () => {
      containerElement?.removeEventListener("wheel", stopAutoScroll);
      containerElement?.removeEventListener("touchmove", stopAutoScroll);
    };
  }, [containerElement]);

  return shouldAutoScroll;
};
